// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavMenu_nav__2Hdsr","divider":"NavMenu_divider__3W-_I","text":"NavMenu_text__fU_Q_","link":"NavMenu_link__1M3-8","link--disabled":"NavMenu_link--disabled__1aOOJ"};